import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  item: {
    margin: 8
  }
})
